var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 8.55005H21V11.5H19V8.55005ZM14.76 12.84L12.96 11.05L11.55 12.46L13.34 14.25L14.76 12.84ZM12 18.5H9V20.5H12V18.5ZM28.45 12.46L27.04 11.05L25.25 12.84L26.66 14.25L28.45 12.46ZM27.03 27.96L25.24 26.16L26.64 24.76L28.44 26.55L27.03 27.96ZM31 18.5H28V20.5H31V18.5ZM14 19.5C14 16.19 16.69 13.5 20 13.5C23.31 13.5 26 16.19 26 19.5C26 22.81 23.31 25.5 20 25.5C16.69 25.5 14 22.81 14 19.5ZM21 30.4501V27.5H19V30.4501H21ZM12.96 27.9501L11.55 26.54L13.34 24.74L14.75 26.15L12.96 27.9501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.4ab742519f6551b999ef0e445accdb59.svg";
export { ForwardRef as ReactComponent };